import React from 'react'
import RegisterNavbar from '../../components/registration/RegisterNavbar'
import RegisterConfirmation from '../../components/registration/RegisterConfirmation'
import Footer from '../../components/common/Footer'


export default function RegisterConfirmationPage() {
  return (
    <>
    <RegisterNavbar/>
    <RegisterConfirmation/>
    <Footer/>
    </>
  )
}